import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import Main from '../components/Main';
import HeroPanel from '../components/HeroPanel';
import Section from '../components/Section';
import Container from '../components/Container';
import Button from '../components/Button';
import IconLink from '../icons/link.svg';
import TechIcon from '../icons/technologies.svg';
import FacebookQuote from '../icons/facebook-quote.svg';
import Graph from '../icons/graph.svg';

function IndexPage({ data }) {
  const { heroPanel } = data.home.edges[0].node.frontmatter;
  const { pageTitle, metaDescription } = data.homeSeo.edges[0].node.frontmatter;
  return (
    <Layout home>
      <>
        <Seo
          title={pageTitle}
          titleTemplate="%s"
          description={metaDescription}
        />
        <Main flush>
          <>
            <HeroPanel
              title={heroPanel.title}
              button={heroPanel.button}
              image={heroPanel.image}
            />
            <Section>
              <Container>
                <>
                  <div className="columns">
                    <div className="column column--fullWidth columnContent">
                      <h2 className="heading2">About Us</h2>
                    </div>
                    <div className="column columnContent">
                      <p className="heading3">
                        Our vision is to improve health and wellness by
                        optimising data assets and digital activation to advance
                        technologies for life.
                      </p>
                      <Button link="/about" modifyer="btnDarkViolet">
                        Learn more
                      </Button>
                    </div>
                    <div className="column columnContent">
                      <p>
                        Opyl is a new generation company that provides leading
                        biopharma and health organisations access to emerging
                        AI-assisted technologies and professional guidance to
                        understand and improve healthcare design, development
                        and delivery.
                      </p>
                    </div>
                    <div className="column">
                      <div className="blockquote">
                        <IconLink />
                        <blockquote>
                          <p>
                            Patients report more about their health experience
                            to social networks than they do to their doctor.
                          </p>
                        </blockquote>
                      </div>
                    </div>
                  </div>
                </>
              </Container>
            </Section>
            <Section modifyer="sectionBase">
              <>
                <div className="sectionImage sectionImage--right">
                  <Img fluid={heroPanel.image.childImageSharp.fluid} />
                </div>
                <Container>
                  <>
                    <div className="columns">
                      <div className="column column--fullWidth columnContent columnContent--dark">
                        <h2 className="heading2">Services</h2>
                      </div>
                      <div className="column columnContent columnContent--dark">
                        <p className="heading3">
                          Market research intelligence is changing and sources
                          of data are expanding as a result of social media. Our
                          team are great listeners and observers and can help
                          you connect to patients on a deeper level.
                        </p>
                        <Button link="/services" modifyer="btnRomantic">
                          Learn more
                        </Button>
                      </div>
                      <div className="column columnContent">
                        <p>
                          We are far more willing to share our health data and
                          opinions than ever before – particularly if it will
                          improve the health experience and result, but also if
                          it can help other people.
                        </p>
                        <p>
                          Our team are great listeners and observers. Market
                          research intelligence is changing and sources of data
                          are expanding thanks to social media.
                        </p>
                      </div>
                    </div>
                  </>
                </Container>
              </>
            </Section>
            <Section>
              <Container>
                <div className="columns">
                  <div className="column column--fullWidth columnContent">
                    <h2 className="heading2">Technologies</h2>
                  </div>
                  <div className="column column--twoThirds columnContent">
                    <div className="iconText">
                      <div className="iconText-icon">
                        <TechIcon />
                      </div>
                      <div className="iconText-text">
                        <p className="heading3">
                          Opyl’s technology research and development pipeline
                          provides lifescience developers and healthcare
                          providers with unprecedented insight and data
                          optimisation opportunities.
                        </p>
                        <Button link="/technologies" modifyer="btnDarkViolet">
                          Learn More
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <div className="blockquote">
                      <FacebookQuote />
                      <blockquote>
                        <p>
                          Facebook is a business-critical tool in recruiting
                          participants into clinical studies.
                        </p>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </Container>
            </Section>
            <Section modifyer="sectionBase">
              <div className="sectionImage sectionImage--left">
                <Img fluid={heroPanel.image.childImageSharp.fluid} />
              </div>
              <Container>
                <div className="columns columns--alignRight">
                  <div className="column column--twoThirds columnContent columnContent--dark">
                    <h2 className="heading2">Investor</h2>
                  </div>
                  <div className="column column--twoThirds columnContent columnContent--dark">
                    <div className="iconText">
                      <div className="iconText-icon">
                        <Graph />
                      </div>
                      <div className="iconText-text">
                        <p className="heading3">
                          Information regarding ASX announcements, Periodic
                          Reports, Presentations and other Investor Resources.
                        </p>
                        <Button link="/investor" modifyer="btnRomantic">
                          Learn More
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </Section>
          </>
        </Main>
      </>
    </Layout>
  );
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }).isRequired,
};

export default IndexPage;

export const query = graphql`
  query {
    home: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "home" } } }
    ) {
      edges {
        node {
          frontmatter {
            pageTitle
            metaDescription
            heroPanel {
              title
              button
              image {
                childImageSharp {
                  fluid(maxWidth: 880, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
    homeSeo: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "homeSeo" } } }
    ) {
      edges {
        node {
          frontmatter {
            pageTitle
            metaDescription
          }
        }
      }
    }
  }
`;
